import Component from '../abstracts/Component';

export default class CartBarComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-cartbar]',
      cta: '.info .product-actions',
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      showSize: 'show-size',
      adding: 'adding',
      added: 'added',
    };
  }

  constructor() {
    super();
    this.mainTarget = $(this.SELECTORS.main);
    this.cta = $(this.SELECTORS.cta);
  }


  showCartbar() {
    if (!this.mainTarget.hasClass(this.CLASSES.show)) {
      this.mainTarget.addClass(this.CLASSES.show);
      this.$emit(this.$customEvents.CARTBAR_EVENTS.cartbaropened);
    }

  }

  hideCartbar() {
    if (this.mainTarget.hasClass(this.CLASSES.show)) {
      this.mainTarget.removeClass(this.CLASSES.show);
      this.$emit(this.$customEvents.CARTBAR_EVENTS.cartbarclosed);
    }

  }

  bindEvents() {

  let ctx = this;
  let $layer = this.mainTarget.find('.js-sizes');


    // usare l'utility che c'è già
    $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top,
          elementBottom = elementTop + $(this).outerHeight(),
          viewportTop = $(window).scrollTop(),
          viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    let bottomEl = document.querySelector('.widget-section .suggestions') || document.querySelector('.widget-section .services') || document.querySelector('.footer-main')

    if (this.$matchMedia(null, 'sm')) {

      window.addEventListener('scroll', (e) => {
        if (!this.cta.isInViewport() && bottomEl.getBoundingClientRect().top >= window.innerHeight ) {
          ctx.showCartbar();
        } else {
          ctx.hideCartbar();
        }
      })

    }  else {

      ctx.showCartbar();
      window.addEventListener('scroll', (e) => {
        if (bottomEl.getBoundingClientRect().top >= window.innerHeight ) {
          ctx.showCartbar();
        } else {
          ctx.hideCartbar();
        }
      })
    }

    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      //if I select size from cart bar
      let $el = $(payload.button);
      let baseCode = $el.data('baseCode');
      if ($el.closest('.cart-bar').length === 1 && !$el.data('disabled')) {
        this.$emit(this.$customEvents.PRODUCT_EVENTS.addtocart, {button: $(`.js-addtocart[data-product-code="${baseCode}"]`)});
      }
    });



    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, ({event, payload}) => {

      let baseCode = $(payload).data('productCode');
      let $parent = $(`[data-cartbar][data-basecode="${baseCode}"]`);
      $(`[data-cartbar][data-basecode="${baseCode}"]`).addClass(this.CLASSES.showSize);

      ctx.$emit(ctx.$customEvents.SIZES_EVENTS.sizesopen, { parent: $parent, layer: $layer } )
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.addtocart, ({event, payload}) => {
      this.mainTarget.removeClass(this.CLASSES.showSize).addClass(this.CLASSES.adding);
      this.$emit(this.$customEvents.SIZES_EVENTS.sizesclose, { layer: $layer } )
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      // ADD SUCCESS MSG
      this.mainTarget.addClass(this.CLASSES.added);
      setTimeout(  () => {
        this.mainTarget.removeClass(this.CLASSES.adding)
        this.mainTarget.removeClass(this.CLASSES.added)
      }, 1500);
    });

  }

  render() {
    if(document.querySelector('.js-cart-dropdown')){
      this.bindEvents();
    }
  }
}
